import { useTranslation } from 'react-i18next';

export default function FeaturesSection() {
  const { t } = useTranslation();

  const features = [
    { icon: 'ri-4k-line', title: t('feature_hd'), desc: t('feature_hd_desc') },
    { icon: 'ri-flashlight-line', title: t('feature_update'), desc: t('feature_update_desc') },
    { icon: 'ri-menu-search-line', title: t('feature_category'), desc: t('feature_category_desc') },
    { icon: 'ri-device-line', title: t('feature_multi'), desc: t('feature_multi_desc') },
  ];

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 text-center mb-10">
          {t('platform_features')}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feat, i) => (
            <div key={i} className="flex flex-col items-center text-center p-6 rounded-lg bg-background-50 border border-background-200/70">
              <span className="w-14 h-14 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                <i className={`${feat.icon} text-xl`}></i>
              </span>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}